import accounts from "./accounts";

const pages = { accounts };

export default pages;